"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ListBoxItem = exports.Header = exports.StyledListBoxItem = exports.UnstyledListBox = exports.InlineListBox = exports.ListBox = exports.ListBoxLoadMoreItem = exports.Section = void 0;
var styled_1 = __importDefault(require("@emotion/styled"));
var React = __importStar(require("react"));
var react_aria_components_1 = require("react-aria-components");
var icons_1 = require("../../icons");
var theme_1 = require("../../theme");
var CheckboxGroup_1 = require("../Forms/CheckboxGroup");
var listStyles_1 = require("../listStyles");
var react_aria_components_2 = require("react-aria-components");
Object.defineProperty(exports, "Section", { enumerable: true, get: function () { return react_aria_components_2.Section; } });
Object.defineProperty(exports, "ListBoxLoadMoreItem", { enumerable: true, get: function () { return react_aria_components_2.ListBoxLoadMoreItem; } });
/**
 * A list box component that displays a list of selectable items.
 * Provides keyboard navigation, selection behavior, and accessibility features.
 *
 * @see {@link https://react-spectrum.adobe.com/react-aria/ListBox.html}
 * @see {@link https://compass.circleci.com/?path=/story/rac-listbox--default}
 *
 * @example
 * ```tsx
 * <ListBox aria-label="Items" selectionMode="single">
 *   <ListBoxItem textValue="Item 1">
 *     <Text>Item 1</Text>
 *   </ListBoxItem>
 *   <ListBoxItem textValue="Item 2">
 *     <Text>Item 2</Text>
 *   </ListBoxItem>
 * </ListBox>
 * ```
 *
 * @param children - The list box items to display
 * @param isDisabled - Whether the list box is disabled
 * @param isReadOnly - Whether the list box is read only
 * @param isRequired - Whether the list box is required
 * @param autoFocus - Whether the list box should receive focus on render
 * @param onFocus - Handler that is called when the list box receives focus
 * @param onBlur - Handler that is called when the list box loses focus
 * @param onFocusChange - Handler that is called when the focus state changes
 * @param id - The element's unique identifier
 * @param aria-label - Defines a string value that labels the current element
 * @param aria-labelledby - Identifies the element (or elements) that labels the current element
 * @param aria-describedby - Identifies the element (or elements) that describes the object
 * @param aria-details - Identifies the element (or elements) that provide a detailed description
 */
exports.ListBox = (0, styled_1.default)(react_aria_components_1.ListBox)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), listStyles_1.ListStyles);
/**
 * A list box component without styling.
 * Use this when the ListBox will be visually contained with other items (e.g. buttons, search box).
 *
 * @example
 * ```tsx
 * <InlineListBox aria-label="Items" selectionMode="single">
 *   <ListBoxItem textValue="Item 1">
 *     <Text>Item 1</Text>
 *   </ListBoxItem>
 *   <ListBoxItem textValue="Item 2">
 *     <Text>Item 2</Text>
 *   </ListBoxItem>
 * </InlineListBox>
 * ```
 *
 * @param children - The list box items to display
 * @param isDisabled - Whether the list box is disabled
 * @param isReadOnly - Whether the list box is read only
 * @param isRequired - Whether the list box is required
 * @param autoFocus - Whether the list box should receive focus on render
 * @param onFocus - Handler that is called when the list box receives focus
 * @param onBlur - Handler that is called when the list box loses focus
 * @param onFocusChange - Handler that is called when the focus state changes
 * @param id - The element's unique identifier
 * @param aria-label - Defines a string value that labels the current element
 * @param aria-labelledby - Identifies the element (or elements) that labels the current element
 * @param aria-describedby - Identifies the element (or elements) that describes the object
 * @param aria-details - Identifies the element (or elements) that provide a detailed description
 */
exports.InlineListBox = (0, styled_1.default)(react_aria_components_1.ListBox)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), listStyles_1.InlineListStyles);
/**
 * @deprecated Use InlineListBox instead. This component has been renamed for better clarity.
 */
exports.UnstyledListBox = exports.InlineListBox;
/**
 * A styled list box item component that displays a single item in a list box.
 *
 * @example
 * ```tsx
 * <StyledListBoxItem textValue="Item 1">
 *   <Text>Item 1</Text>
 * </StyledListBoxItem>
 * ```
 *
 * @param children - The content to display inside the list box item
 * @param isDisabled - Whether the list box item is disabled
 * @param isSelected - Whether the list box item is selected
 * @param onAction - Handler that is called when the item is selected
 * @param onFocus - Handler that is called when the item receives focus
 * @param onBlur - Handler that is called when the item loses focus
 * @param onFocusChange - Handler that is called when the focus state changes
 * @param autoFocus - Whether the item should receive focus on render
 * @param id - The element's unique identifier
 * @param aria-label - Defines a string value that labels the current element
 * @param aria-labelledby - Identifies the element (or elements) that labels the current element
 * @param aria-describedby - Identifies the element (or elements) that describes the object
 * @param aria-details - Identifies the element (or elements) that provide a detailed description
 */
exports.StyledListBoxItem = (0, styled_1.default)(react_aria_components_1.ListBoxItem)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), listStyles_1.ListItemStyles);
var ContentContainer = styled_1.default.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  min-width: 0;\n  flex-grow: 1;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  overflow: hidden;\n"], ["\n  min-width: 0;\n  flex-grow: 1;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  overflow: hidden;\n"])));
/**
 * A header component for the list box that displays a title or section header.
 *
 * @example
 * ```tsx
 * <Header>
 *   <Text>Section Title</Text>
 * </Header>
 * ```
 *
 * @param children - The content to display in the header
 * @param id - The element's unique identifier
 * @param aria-label - Defines a string value that labels the current element
 * @param aria-labelledby - Identifies the element (or elements) that labels the current element
 * @param aria-describedby - Identifies the element (or elements) that describes the object
 * @param aria-details - Identifies the element (or elements) that provide a detailed description
 */
exports.Header = (0, styled_1.default)(react_aria_components_1.Header)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  display: flex;\n  gap: ", ";\n  background-color: ", ";\n  padding: ", " ", ";\n"], ["\n  display: flex;\n  gap: ", ";\n  background-color: ", ";\n  padding: ", " ", ";\n"])), theme_1.theme.space.space8, theme_1.theme.colors.n40, theme_1.theme.space.space8, theme_1.theme.space.space24);
/**
 * A list box item component that displays a single item with a check icon when selected.
 *
 * @example
 * ```tsx
 * <ListBoxItem textValue="Item 1">
 *   <Text>Item 1</Text>
 * </ListBoxItem>
 * ```
 *
 * @param children - The content to display inside the list box item
 * @param isDisabled - Whether the list box item is disabled
 * @param isSelected - Whether the list box item is selected
 * @param onAction - Handler that is called when the item is selected
 * @param onFocus - Handler that is called when the item receives focus
 * @param onBlur - Handler that is called when the item loses focus
 * @param onFocusChange - Handler that is called when the focus state changes
 * @param autoFocus - Whether the item should receive focus on render
 * @param id - The element's unique identifier
 * @param aria-label - Defines a string value that labels the current element
 * @param aria-labelledby - Identifies the element (or elements) that labels the current element
 * @param aria-describedby - Identifies the element (or elements) that describes the object
 * @param aria-details - Identifies the element (or elements) that provide a detailed description
 */
var ListBoxItem = function (_a) {
    var backgroundType = _a.backgroundType, children = _a.children, props = __rest(_a, ["backgroundType", "children"]);
    return (React.createElement(exports.StyledListBoxItem, __assign({}, props, { "data-negative": backgroundType === 'negative' }), function (_a) {
        var isSelected = _a.isSelected, selectionMode = _a.selectionMode;
        return (React.createElement(React.Fragment, null,
            selectionMode === 'multiple' && (React.createElement(CheckboxGroup_1.CheckboxElement, { isSelected: isSelected, isIndeterminate: false, isPressed: false, isFocusVisible: false, isInvalid: false })),
            React.createElement(ContentContainer, null, children),
            selectionMode === 'single' && isSelected && (React.createElement(icons_1.CheckIcon, { size: 20, style: { marginLeft: 'auto' } }))));
    }));
};
exports.ListBoxItem = ListBoxItem;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;
//# sourceMappingURL=index.js.map